module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "centeraaf"
  }, [_c('a', {
    attrs: {
      "id": "ded"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Don’t be afraid of darkness,"), _c('br'), _vm._v("for in darkness rests the light."), _c('br'), _vm._v("We see no stars or planets"), _c('br'), _vm._v("without the dark of night."), _c('br'), _vm._v("The darkness of the pupil"), _c('br'), _vm._v("is in the iris round,"), _c('br'), _vm._v("for all light’s fearful longing"), _c('br'), _vm._v("has darkness at its ground."), _c('br'), _vm._v("Don’t be afraid of darkness,"), _c('br'), _vm._v("for in it rests the light."), _c('br'), _vm._v("Don’t be afraid of darkness;"), _c('br'), _vm._v("it holds the heart of light")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("—Erik Blomberg")]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-508c5c15","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ded.vue
// module id = 75
// module chunks = 0